import Axios from "axios";
import {
  saveUpdatePurInvoice,
  getPurInvoiceList,
  getPurInvoiceById as getPurInvoiceByIdApi,
  saveSupplierPayment,
  getPurchaseSupplierPayments,
} from "@/store/api";
import {
  SET_PUR_INVOICE_LIST,
  UNSET_PUR_INVOICE_LIST,
  SET_SUPPLIER_PAYMENT_LIST,
  UNSET_SUPPLIER_PAYMENT_LIST,
} from "@/store/mutation-types";

const state = {
  purchaseInvoiceList: [],
  supplierPaymentList: [],
};

const getters = {
  getPurInvoiceList(state) {
    return state.purchaseInvoiceList;
  },
  getSupplierPaymentList(state) {
    return state.supplierPaymentList;
  },
};

const mutations = {
  [SET_PUR_INVOICE_LIST](state, data) {
    state.purchaseInvoiceList = data;
  },
  [UNSET_PUR_INVOICE_LIST](state) {
    state.purchaseInvoiceList = [];
  },
  [SET_SUPPLIER_PAYMENT_LIST](state, data) {
    state.supplierPaymentList = data;
  },
  [UNSET_SUPPLIER_PAYMENT_LIST](state) {
    state.supplierPaymentList = [];
  },
};

const actions = {
  saveUpdatePurInvoice({ commit }, data) {
    commit("SET_LOADING", { color: "primary" });
    return new Promise((resolve, reject) => {
      Axios.post(saveUpdatePurInvoice, data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING");
        });
    });
  },

  getPurInvoiceList({ commit }, params) {
    return new Promise((resolve, reject) => {
      Axios.post(getPurInvoiceList, params)
        .then((response) => {
          commit(SET_PUR_INVOICE_LIST, response.data.data || []);
          resolve(response);
        })
        .catch((error) => {
          commit(UNSET_PUR_INVOICE_LIST);
          reject(error);
        });
    });
  },

  getPurInvoiceById({ commit }, id) {
    const url = `${getPurInvoiceByIdApi}/${id}`;
    commit("SET_LOADING", { color: "primary" });
    return new Promise((resolve, reject) => {
      Axios.post(url)
        .then((response) => {
          resolve(response.data.data);
        })
        .catch((error) => {
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING");
        });
    });
  },

  saveSupplierPayment({ commit }, data) {
    commit("SET_LOADING", { color: "primary" });
    return new Promise((resolve, reject) => {
      Axios.post(saveSupplierPayment, data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING");
        });
    });
  },

  getPurchaseSupplierPayments({ commit }, params) {
    return new Promise((resolve, reject) => {
      Axios.post(getPurchaseSupplierPayments, params)
        .then((response) => {
          commit(SET_SUPPLIER_PAYMENT_LIST, response.data.data || []);
          resolve(response);
        })
        .catch((error) => {
          commit(UNSET_SUPPLIER_PAYMENT_LIST);
          reject(error);
        });
    });
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};

